import { RouteConfig } from "vue-router";
import DashboardLayout from "@/layout/DashboardLayout.vue";
import Menu from "@/views/dashboard/Menu.vue";
import store from "@/store";
import { apolloClient } from "@/apollo";
import { GET_MENU_TYPE } from "@/queries/user/query.graphql";
import { ifAuthenticated } from "./utils";

export const dashRoutes: Array<RouteConfig> = [
  {
    path: "/dashboard",
    // redirect: "dashboard",
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    children: [
      { path: "/dashboard", redirect: "menu" },
      {
        path: "settings",
        name: "settings",
        component: () => import("@/views/dashboard/UserSettings.vue")
      },
      {
        path: "pdf",
        name: "pdf",
        component: () => import("@/views/dashboard/PDFView.vue"),
        beforeEnter: async (to, from, next) => {
          store.commit("loadersModule/toggleGlobalLoader", true);
          const { data, loading, errors } = await apolloClient.query({
            query: GET_MENU_TYPE
          });
          store.commit("loadersModule/toggleGlobalLoader", false);
          if (data) {
            if (data.Menu[0] && data.Menu[0].menuType === "ONLINE") {
              next({ name: "menu" });
              return;
            } else if (data.Menu[0] && data.Menu[0].menuType === "PDF") {
              next();
            }
          }
          if (errors) {
            // store.commit("authModule/logout");
            // next({ name: "login" });
          }
        }
      },
      {
        path: "menu",
        component: Menu,
        name: "menu",
        beforeEnter: async (to, from, next) => {
          store.commit("loadersModule/toggleGlobalLoader", true);
          const { data, loading, errors } = await apolloClient.query({
            query: GET_MENU_TYPE
          });
          store.commit("loadersModule/toggleGlobalLoader", false);
          if (data) {
            if (data.Menu[0] && data.Menu[0].menuType === "ONLINE") {
              next();
              return;
            } else if (data.Menu[0] && data.Menu[0].menuType === "PDF") {
              next({ name: "pdf" });
            }
          }
          if (errors) {
            // store.commit("authModule/logout");
            // next({ name: "login" });
          }
        },
        children: [
          {
            path: "item/:categoryId/:itemId",
            component: () =>
              import("@/views/dashboard/DashboardMenuItemDetails.vue"),
            name: "menu-dish",
            meta: {
              fullOnMobile: true
            }
          }
        ]
      },
      {
        name: "orders",
        path: "orders",
        component: () => import("@/views/dashboard/DashboardOrders.vue")
      }
    ]
  }
];
